import template from "./radniNalogList.html";
import ListController from "../common/list.controller.js";

class RadniNalogListController {
    constructor(DS, AppConfiguration, $q, $state, RadniNalogService) {
        this.DS = () => DS;
        this.$q = $q;
        this.$state = $state;
        this.view = AppConfiguration().getViewByEntityAndType(
            "RadniNalog",
            "ListView"
        );

        this.icon = this.view.icon();
        this.pageTitle = this.view.title();
        this.pageDesc = this.view.description();

        this.RadniNalogService = () => RadniNalogService;
        this.pager = RadniNalogService.getPager();
        this.filter = RadniNalogService.getFilter();
    }

    $onInit() {
        this.refreshState();
    }

    refreshState() {
        const RadniNalogService = this.RadniNalogService();
        RadniNalogService.fetchRadneNaloge().then(response => {
            this.items = response;
            this.pager = RadniNalogService.getPager();
        });
    }

    pageChanged() {
        const RadniNalogService = this.RadniNalogService();
        const pager = RadniNalogService.getPager();
        RadniNalogService.setPager({ currentPage: this.pager.currentPage });
        this.refreshState();
    }

    onFilter(value) {
        let filter = { search: value };
        const RadniNalogService = this.RadniNalogService();
        RadniNalogService.setFilter({ ...filter });
        RadniNalogService.setPager({ currentPage: 1 });
        this.refreshState();
    }

    edit(item) {
        this.$state.go("radniNalog.details", { id: item.id });
    }
}

RadniNalogListController.$inject = [
    "DS",
    "AppConfiguration",
    "$q",
    "$state",
    "RadniNalogService"
];

const RadniNalogListComponent = {
    restrict: "E",
    templateUrl: template,
    controller: RadniNalogListController,
    controllerAs: "vm"
};

export { RadniNalogListComponent };
export { RadniNalogListController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalogList.component.js